import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";

import { Header } from "@/components/Header";
import { VipChatPanel } from "@/components/vip-chat/VipChatPanel";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";
import { useDevState } from "@/lib/dev-state";
import { isSuperSubMember } from "@/lib/membership-tier";

export const Route = createFileRoute("/vip-chat")({
  head: () => ({
    meta: [
      { title: "VIP Chat — Real Pranks" },
      {
        name: "description",
        content: "Chat with Ross and other Super Subs in the synced VIP group.",
      },
    ],
  }),
  component: VipChatPage,
});

function VipChatPage() {
  const { signedIn, loading, user, subscriptions } = useAuth();
  const dev = useDevState();
  const navigate = useNavigate();
  const canAccess = isSuperSubMember(subscriptions, dev.state === "real" ? undefined : dev.tier);

  useEffect(() => {
    if (loading) return;
    if (!signedIn) {
      navigate({ to: "/login", search: { redirect: "/vip-chat" } });
      return;
    }
    if (!canAccess) {
      navigate({ to: "/membership", search: { tier: "super sub" } });
    }
  }, [canAccess, loading, navigate, signedIn]);

  if (loading || !signedIn || !canAccess || !user) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="flex min-h-[50vh] items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto w-full max-w-4xl px-4 py-8">
        <div className="mb-4 flex items-center justify-between gap-3">
          <Button asChild variant="ghost" size="sm">
            <Link to="/account">Back to account</Link>
          </Button>
        </div>
        <VipChatPanel userId={user.uid} />
      </main>
    </div>
  );
}
